/**
 * Created by hp on 2017/8/22.
 */
import React, {Component} from 'react';
import axios from 'axios';
import qs from 'qs';
import {Button, CellBody, CellHeader, Form, FormCell, Input, Label, Toast, Dialog} from 'react-weui';
import {WKVisible} from '../../components/wk'
import {storage} from '../../utils'


class LiveroomVerifyForm extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleVerifyFields = this.handleVerifyFields.bind(this);

        const {personReq, companyReq} = this.props;
        this.state = {
            alert: {
                show: false,
                text: null,
                title: null,
                buttons: []
            },
            _realname: (personReq && personReq.realname) || '',
            _address: (personReq && personReq.address) || '',
            _wechat: (personReq && personReq.wechat) || '',
            _sfz_id: (personReq && personReq.sfz_id) || '',

            realname: (companyReq && companyReq.realname) || '',
            address: (companyReq && companyReq.address) || '',
            wechat: (companyReq && companyReq.wechat) || '',
            sfz_id: (companyReq && companyReq.sfz_id) || '',
            company: (companyReq && companyReq.company) || '',
            brand: (companyReq && companyReq.brand) || '',
            official: (companyReq && companyReq.official) || '',
            tax_id: (companyReq && companyReq.tax_id) || '',
            fieldsNameMap: {
                realname: '运营者姓名',
                sfz_id: '运营者身份证',
                wechat: '运营者微信号',
                address: '联系地址',
                company: '企业名称',
                brand: '品牌名称',
                official: '公众号',
                tax_id: '企业税号',
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        let {personReq, companyReq, isVerify, status} = nextProps

        // 请求认证中，直接返回
        if (!isVerify) return
        // 初始状态不校验
        if (status === 'default') return

        if (!personReq) {
            personReq = {realname: '', address: '', wechat: '', sfz_id: ''}
        }
        if (!companyReq) {
            companyReq = {realname: '', address: '', wechat: '', sfz_id: '', company: '', brand: '', official: '', tax_id: ''}
        }
        const {realname, address, wechat, sfz_id, company, brand, official, tax_id} = companyReq
        this.setState({
            _realname: personReq.realname,
            _address: personReq.address,
            _wechat: personReq.wechat,
            _sfz_id: personReq.sfz_id,
            realname,
            address,
            wechat,
            sfz_id,
            company,
            brand,
            official,
            tax_id
        })
    }

    showAlert(text, callback, title) {
        this.setState({
            alert: {
                text: text,
                title: title,
                show: true,
                buttons: [{
                    label: '好',
                    onClick: e => {
                        this.setState({alert: {show: false}});
                        callback && callback()
                    }
                }]
            }
        })
    }

    handleSubmit() {
        const {selectType, handleVerify, liveroomId} = this.props;
        let data = {};
        if (selectType === 'person') {
            data = {
                realname: this.state._realname,
                address: this.state._address,
                wechat: this.state._wechat,
                sfz_id: this.state._sfz_id,
                type: 'person'
            }
        }
        if (selectType === 'company') {
            data = {
                realname: this.state.realname,
                address: this.state.address,
                wechat: this.state.wechat,
                sfz_id: this.state.sfz_id,
                company: this.state.company,
                brand: this.state.brand,
                official: this.state.official,
                tax_id: this.state.tax_id,
                type: 'company'
            }
        }

        // 校验表单字段
        for (let i in data) {
            let flag = this.handleVerifyFields(i, data[i]);
            if (flag) return;
        }
        this.setState({ isPending: true })
        axios.post(`/api/liveroom/${liveroomId}/verify`, qs.stringify(data)).then(res => {
            this.setState({ isPending: false })
            handleVerify();
        });
    }

    handleVerifyFields(field, fieldVal) {
        const {fieldsNameMap} = this.state;

        if (!fieldVal || fieldVal.trim() === '') {
            this.showAlert(fieldsNameMap[field] + '是必填项')
            return true;
        }
        return false;
    }

    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
        this.setLocalStorage(field, e.target.value)
    }

    setLocalStorage(field, value) {
        const {selectType, status} = this.props
        if (status === 'default') {
            if (selectType === 'person') {
                let key = 'liveroom-verify__person'
                let personVerify = storage.getItem(key)
                if (personVerify) {
                    storage.setItem(key, Object.assign(personVerify, {[field.substr(1)]: value}))
                } else {
                    storage.setItem(key, {[field.substr(1)]: value, type: 'person'})
                }
            }
            if (selectType === 'company') {
                let key = 'liveroom-verify__company'
                let companyVerify = storage.getItem(key)
                if (companyVerify) {
                    storage.setItem(key, Object.assign(companyVerify, {[field]: value}))
                } else {
                    storage.setItem(key, {[field]: value, type: 'company'})
                }
            }
        }
    }

    renderCell (opts) {
        const {status} = this.props
        return (
            <FormCell>
                <CellHeader>
                    <Label>{opts.label}<span className="liveroom-verify-star">*</span></Label>
                </CellHeader>
                <CellBody>
                    {(status === 'success' || status === 'review') ?
                        <Input type={opts.type || 'text'} value={opts.value} disabled/>
                        :
                        <Input type={opts.type || 'text'} placeholder={opts.placeholder} onChange={e => this.bindValue(e, opts.field)} value={opts.value}/>
                    }
                </CellBody>
            </FormCell>
        )
    }

    render() {
        const {selectType, status} = this.props;

        return (
            <div className="liveroom-verify-form">
                <p className="verify-title">选择认证类型</p>

                <Form>
                    <WKVisible show={selectType === 'person'}>
                        {this.renderCell({label:"运营者姓名", placeholder:"请输入姓名", field: '_realname', value: this.state._realname})}
                        {this.renderCell({label:"运营者身份证", placeholder:"请输入身份证或护照ID", field: '_sfz_id', value: this.state._sfz_id})}
                        {this.renderCell({label:"运营者微信号", placeholder:"请输入微信号", field: '_wechat', value: this.state._wechat})}
                        {this.renderCell({label:"联系地址", placeholder:"请输入地址", field: '_address', value: this.state._address})}
                    </WKVisible>
                    <WKVisible show={selectType === 'company'}>
                        <div className="weui-cells">
                            {this.renderCell({label:"运营者姓名", placeholder:"请输入姓名", field: 'realname', value: this.state.realname})}
                            {this.renderCell({label:"运营者身份证", placeholder:"请输入身份证或护照ID", field: 'sfz_id', value: this.state.sfz_id})}
                            {this.renderCell({label:"运营者微信号", placeholder:"请输入微信号", field: 'wechat', value: this.state.wechat})}
                            {this.renderCell({label:"联系地址", placeholder:"请输入地址", field: 'address', value: this.state.address})}
                            {this.renderCell({label:"企业名称", placeholder:"请输入企业全称", field: 'company', value: this.state.company})}
                            {this.renderCell({label:"企业税号", placeholder:"请输入用于开发票的企业税号", field: 'tax_id', value: this.state.tax_id})}
                            {this.renderCell({label:"品牌名称", placeholder:"请输入企业旗下品牌名称", field: 'brand', value: this.state.brand})}
                            {this.renderCell({label:"公众号", placeholder:"请输入公众号名称", field: 'official', value: this.state.official})}
                        </div>
                    </WKVisible>
                </Form>

                <div className="submit-btn">
                    {(status === 'failed' || status === 'default') &&
                    <Button onClick={this.handleSubmit}>提交申请</Button>
                    }
                    {status === 'review' &&
                    <Button className="verify-review-btn">审核中</Button>
                    }
                    {status === 'success' &&
                    <Button className="verify-success-btn" disabled>
                        {selectType === 'person' ? "已个人认证" : "已机构认证"}
                    </Button>
                    }
                </div>
                {status === 'success' &&
                <p className="re-verify-text" onClick={() => this.context.page.props.parent.setStatus('default')}>重新认证 > </p>
                }
                <Toast icon="loading" show={this.state.isPending}/>
                <Dialog type="ios" title={this.state.alert.title}
                        buttons={this.state.alert.buttons}
                        show={this.state.alert.show}
                        className="page-alert">
                    {this.state.alert.text}
                </Dialog>
            </div>
        )
    }
}

LiveroomVerifyForm.contextTypes = {
    page: React.PropTypes.object
};

export default LiveroomVerifyForm;


// WEBPACK FOOTER //
// ./src/components/liveroomVerify/LiveroomVerifyForm.js